var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 8.9002L5.1 8.5002L4.3 9.10019L4.6 9.5002L5.4 8.9002ZM11.4 9.5002L11.7 9.10019L10.9 8.5002L10.6 8.9002L11.4 9.5002ZM8 14.2002C4.41015 14.2002 1.5 11.29 1.5 7.7002H0.5C0.5 11.8423 3.85786 15.2002 8 15.2002V14.2002ZM14.5 7.7002C14.5 11.29 11.5899 14.2002 8 14.2002V15.2002C12.1421 15.2002 15.5 11.8423 15.5 7.7002H14.5ZM8 1.2002C11.5899 1.2002 14.5 4.11034 14.5 7.7002H15.5C15.5 3.55806 12.1421 0.200195 8 0.200195V1.2002ZM8 0.200195C3.85786 0.200195 0.5 3.55806 0.5 7.7002H1.5C1.5 4.11034 4.41015 1.2002 8 1.2002V0.200195ZM4.5 6.2002H5.5V5.2002H4.5V6.2002ZM10.5 6.2002H11.5V5.2002H10.5V6.2002ZM10.6 8.9002C9.3 10.6335 6.7 10.6335 5.4 8.9002L4.6 9.5002C6.3 11.7669 9.7 11.7669 11.4 9.5002L10.6 8.9002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.50445b1836e1c3ab7790b6f17144204c.svg";
export { ForwardRef as ReactComponent };